/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type DeleteFormFieldModal_formField$ref = any;
type FormFieldForm_formField$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type FormFieldCard_formField$ref: FragmentReference;
declare export opaque type FormFieldCard_formField$fragmentType: FormFieldCard_formField$ref;
export type FormFieldCard_formField = {|
  +id: string,
  +$fragmentRefs: FormFieldForm_formField$ref & DeleteFormFieldModal_formField$ref,
  +$refType: FormFieldCard_formField$ref,
|};
export type FormFieldCard_formField$data = FormFieldCard_formField;
export type FormFieldCard_formField$key = {
  +$data?: FormFieldCard_formField$data,
  +$fragmentRefs: FormFieldCard_formField$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "FormFieldCard_formField",
  "type": "FormField",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FormFieldForm_formField",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "DeleteFormFieldModal_formField",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a853930aac500199f7ff854feceab213';
module.exports = node;
